export const ThunkStatusEnum = {
	LOADING: "loading",
	SUCCESS: "success",
	ERROR: "error",
	IDLE: "idle",
} as const;
export type ThunkStatusEnum = (typeof ThunkStatusEnum)[keyof typeof ThunkStatusEnum];

export type VariantType = "default" | "coral" | "green" | "sky";

export const DayOfWeek = {
	SUNDAY: 0,
	MONDAY: 1,
	TUESDAY: 2,
	WEDNESDAY: 3,
	THURSDAY: 4,
	FRIDAY: 5,
	SATURDAY: 6,
} as const;
export type DayOfWeek = (typeof DayOfWeek)[keyof typeof DayOfWeek];

export const CalendarProvider = {
	GOOGLE: "google",
	OUTLOOK: "outlook",
} as const;
export type CalendarProvider = (typeof CalendarProvider)[keyof typeof CalendarProvider];

export const AppLanguage = {
	EN: "en",
	ES: "es",
	FR: "fr",
	PT_BR: "pt-BR",
} as const;
export type AppLanguage = (typeof AppLanguage)[keyof typeof AppLanguage];

export const LogLevel = {
	INFO: "info",
	WARNING: "warning",
} as const;
export type LogLevel = (typeof LogLevel)[keyof typeof LogLevel];
